export const ACTION_NAMES = {
  register: "REGISTER",
  login: "LOGIN",
  resetPassword: "RESET",
};
